import React, { useEffect } from 'react';
import Faq from '../components/Faq';
import {
  OFFER_FAQ,
  OFFER_FORM_PATH,
  OfferComparison,
  OfferEcommerce,
  OfferFinalCta,
  OfferHero,
  OfferLocalLinks,
  OfferTrust,
  OfferMobileCtaBar,
  OfferProblem,
  OfferPricing,
  OfferReferences,
  OfferSteps,
  COMMITMENT_MONTHS,
  MONTHLY_PRICE,
  SERVICE_AREAS,
  SERVICE_AUDIENCE,
  SERVICE_NAME,
  SERVICE_TYPE,
  SETUP_PRICE,
  SEO_DESCRIPTION,
  SEO_TITLE,
} from '../components/WebsiteOffer';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { useScrollToHash } from '../hooks/useScrollToHash';
import { trackWebsiteOfferCta } from '../utils/analytics';
import { buildFaqSchema, buildWebsiteServiceSchema } from '../utils/structuredData';

const trackFaqContact = (): void => trackWebsiteOfferCta('faq', 'form');

const OFFER_JSON_LD = [
  buildWebsiteServiceSchema({
    name: SERVICE_NAME,
    serviceType: SERVICE_TYPE,
    path: '/creation-site-web',
    audience: SERVICE_AUDIENCE,
    areas: SERVICE_AREAS,
    setupPrice: SETUP_PRICE,
    setupDescription: 'Création et mise en ligne',
    monthlyPrice: MONTHLY_PRICE,
    monthlyDescription: 'Maintenance, mises à jour et modifications mensuelles (hébergement et nom de domaine non inclus)',
    commitmentMonths: COMMITMENT_MONTHS,
  }),
  buildFaqSchema(OFFER_FAQ),
];

const CreationSiteWeb: React.FC = () => {
  useSeoMeta({
    title: SEO_TITLE,
    description: SEO_DESCRIPTION,
    path: '/creation-site-web',
    jsonLd: OFFER_JSON_LD,
  });
  useScrollToHash();

  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-header md:pt-header-md pb-24 md:pb-0">
      <OfferHero />
      <OfferProblem />
      <OfferSteps />
      <OfferPricing />
      <OfferComparison />
      <OfferTrust />
      <OfferReferences />
      <OfferLocalLinks />
      <Faq showLink={false} items={OFFER_FAQ} contactTo={OFFER_FORM_PATH} onContactClick={trackFaqContact} />
      <OfferEcommerce />
      <OfferFinalCta />
      <OfferMobileCtaBar />
    </div>
  );
};

export default CreationSiteWeb;
